module.exports = __webpack_public_path__ + "static/media/equity.7b574d8a.svg";